import styled from "styled-components";
import {styledByDevice} from "../../../themes/architecture/styled-by-device";
import {CssRule} from "../../../themes/architecture/css-helpers/css-rule";

const CommonStyles = styled.div`
  display: flex;
  flex-direction: row;
  margin: 0;
`;

const PCBox = CommonStyles;

const MobileBox = styled(CommonStyles)`
 margin: 10px auto;
 display: grid;
 grid-template-columns: repeat(3, 130px);
 grid-gap: 10px;
 justify-content: center;
 
 ${CssRule.For.mobile.landscape.build()} & {
   grid-template-columns: repeat(5, 130px);
  }
  
  @media ${({theme}) => theme.mediaQuery.sAndBelow} {
      grid-template-columns: repeat(3, 100px);
      
      ${CssRule.For.mobile.landscape.build()} & {
       grid-template-columns: repeat(5, 100px);
      }
  }
`;


export const FiltersGamesListDefaultBox = styledByDevice(PCBox, MobileBox);